
import '../classifieds.css';
import React from 'react';
import { featuredAds } from '../data/classifieds';
import { Link } from 'react-router-dom';

// Material Icons CDN (for browser)
// Add this in your public/index.html if not already present:
// <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

const Classifieds = () => {
  return (
    <div style={{ paddingLeft: 10 }}>
      {/* Category Titles with Logos */}
      <div className="category-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.1rem 1.5rem', alignItems: 'center', marginBottom: '0.7rem', marginTop: '0.5rem', maxWidth: 400 }}>
        {/* Use a single color for all icons and titles */}
        <Link to="/buyorsellgeneral" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span className="material-icons category-icon" style={{ color: '#388e3c' }}>shopping_cart</span>
            <span style={{ fontWeight: 600, fontSize: '1.05rem', color: '#222' }}>Buy/Sell</span>
          </div>
        </Link>
        <Link to="/services" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span className="material-icons category-icon" style={{ color: '#ff9800' }}>build</span>
            <span style={{ fontWeight: 600, fontSize: '1.05rem', color: '#222' }}>Services</span>
          </div>
        </Link>
        <Link to="/hotels" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span className="material-icons category-icon" style={{ color: '#ef6c00' }}>hotel</span>
            <span style={{ fontWeight: 600, fontSize: '1.05rem', color: '#222' }}>Hotels</span>
          </div>
        </Link>
        <Link to="/jobs" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span className="material-icons category-icon" style={{ color: '#0288d1' }}>work</span>
            <span style={{ fontWeight: 600, fontSize: '1.05rem', color: '#222' }}>Jobs</span>
          </div>
        </Link>
        <Link to="/rentals" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span className="material-icons category-icon" style={{ color: '#5e35b1' }}>directions_car</span>
            <span style={{ fontWeight: 600, fontSize: '1.05rem', color: '#222' }}>Rentals</span>
          </div>
        </Link>
        <Link to="/flyers" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span className="material-icons category-icon" style={{ color: '#00838f' }}>campaign</span>
            <span style={{ fontWeight: 600, fontSize: '1.05rem', color: '#222' }}>Flyers</span>
          </div>
        </Link>
        <Link to="/educational" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span className="material-icons category-icon" style={{ color: '#1976d2' }}>school</span>
            <span style={{ fontWeight: 600, fontSize: '1.05rem', color: '#222' }}>Educational</span>
          </div>
        </Link>
        <Link to="/realestate" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span className="material-icons category-icon" style={{ color: '#388e3c' }}>home_work</span>
            <span style={{ fontWeight: 600, fontSize: '1.05rem', color: '#222' }}>Real Estate</span>
          </div>
        </Link>
        <Link to="/eventsplanning" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span className="material-icons category-icon" style={{ color: '#fbc02d' }}>event</span>
            <span style={{ fontWeight: 600, fontSize: '1.05rem', color: '#222' }}>Events Planning</span>
          </div>
        </Link>
        <Link to="/accomodation" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span className="material-icons category-icon" style={{ color: '#6a1b9a' }}>meeting_room</span>
            <span style={{ fontWeight: 600, fontSize: '1.05rem', color: '#222' }}>Accomodation</span>
          </div>
        </Link>
        <Link to="/specials" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span className="material-icons category-icon" style={{ color: '#d32f2f' }}>star</span>
            <span style={{ fontWeight: 600, fontSize: '1.05rem', color: '#222' }}>Specials</span>
          </div>
        </Link>
      </div>
      
    <div>
  <div style={{ height: '0.7rem' }} />
        <h3 style={{ color: '#d32f2f', fontWeight: 600, fontSize: '1.15rem', margin: 0, padding: 0, marginBottom: '0.5rem' }}>Featured Ads</h3>
        <div>
          <div className="featured-ads-grid">
            {featuredAds.map(ad => (
              <div key={ad.id} style={{ wordBreak: 'break-word', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: 0, padding: 0, background: 'none', border: 'none' }}>
                <div style={{ fontWeight: 'bold', fontSize: '1rem', margin: 0, padding: 0 }}>{ad.title}</div>
                <div style={{ fontSize: '0.95rem', color: '#388e3c', fontWeight: 'bold', margin: 0, padding: 0 }}>{ad.description}</div>
                <div style={{ fontSize: '0.9rem', color: '#757575', margin: 0, padding: 0 }}>Contact: {ad.contact}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Classifieds;
